import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { FolderOpen, Search } from 'lucide-react'
import { api } from '../lib/api'
import type { PatientResume } from '../lib/types'
import { Modale } from './base'
import * as f from '../lib/format'

/** Choix d'un dossier, pour une action lancée depuis l'accueil. */
export default function SelecteurPatient({
  titre,
  sousTitre,
  fermer,
  choisir,
}: {
  titre: string
  sousTitre?: string
  fermer: () => void
  choisir: (patient: PatientResume) => void
}) {
  const [saisie, setSaisie] = useState('')
  const [terme, setTerme] = useState('')

  useEffect(() => {
    const minuteur = setTimeout(() => setTerme(saisie.trim()), 200)
    return () => clearTimeout(minuteur)
  }, [saisie])

  const { data } = useQuery({
    queryKey: ['patients', terme],
    queryFn: () =>
      api<{ patients: PatientResume[] }>(
        `/api/patients?limite=20${terme ? `&q=${encodeURIComponent(terme)}` : ''}`,
      ),
  })

  return (
    <Modale titre={titre} sousTitre={sousTitre} fermer={fermer}>
      <div className="relative mb-3">
        <Search className="pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-brume" />
        <input
          className="champ pl-9"
          autoFocus
          placeholder="Nom, prénom ou référence"
          value={saisie}
          onChange={(e) => setSaisie(e.target.value)}
        />
      </div>

      <div className="max-h-[50vh] overflow-y-auto">
        {data?.patients.length === 0 && (
          <p className="py-6 text-center text-[13px] text-brume">Aucun dossier trouvé.</p>
        )}
        {data?.patients.map((p) => (
          <button
            key={p.id}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left hover:bg-bleu-50"
            onClick={() => choisir(p)}
          >
            <FolderOpen className="h-4 w-4 text-bleu-400" />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[14px] text-encre">{p.affichage}</span>
              <span className="block truncate text-[12px] text-brume">
                {p.reference}
                {p.dateNaissance ? ` · née le ${f.dateCourte(p.dateNaissance)}` : ''}
                {p.fusionne ? ' · dossier fusionné' : ''}
              </span>
            </span>
          </button>
        ))}
      </div>
    </Modale>
  )
}
